
<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <div class="select-container">

    <p
    [ngStyle]="{'color': settings?.general?.textColors || '#000000'}"
    class="canary-click"
    >{{ 'TITLE' | translate:'SELECT-MARKET' | async }}</p>

    <!-- TODO: Comentar con Core tipado del value y valueChange (¿debería ser any? ¿T?) -->
    <render-select
      withFilter="true"
      [value]="{ 'store': selectedStore,  'lang': selectedLanguage }"
      (valueChange)="onMarketChange($any($event))"
    >
      <ng-container *ngFor="let store of stores; trackBy: trackByIndex">
        <render-select-option
        *ngFor="let language of store.supportedLanguages; trackBy: trackByIndex"
        [value]="{ 'store': store, 'lang': language }"
        [text]="store.countryName + ' - ' + language.name">
        {{ store.countryName }} ({{ language.name }})
      </render-select-option>
    </ng-container>
  </render-select>

  <div class="remember-market">
    <label
      class="remember-selection"
      for="remember-selection"
    >{{ 'SAVE' | translate:'SELECT-MARKET' | async }}</label>
    <input
      (input)="rememberMarket($event)"
      id="remember-selection"
      type="checkbox"
    >
  </div>

  <p
  *ngIf="selectedStore?.countryCode === 'ES'"
  [ngStyle]="{'color': settings?.general?.textColors || '#000000'}"
  class="canary-click"
  >Si nos visitas desde Canarias, haz click <a (click)="selectCanary()">aquí</a></p>

  <button
    (click)="goToHome()"
    class="select-market-button"
  > Acceder </button>
</div>
</idt-common-styles-render>
